<template>
		<v-list dense rounded v-if="data">
			<v-list-item>
				<v-list-item-content>
					<v-text-field
						v-model="data.label"
						:rules="[(v) => !!v || 'Label is mandatory']"
						required
						label="Label"
						prepend-icon="mdi-label"
						filled
					/>
				</v-list-item-content>
			</v-list-item>
			<v-list-item>
				<v-list-item-content>
					<v-text-field
						:rules="[(v) => !!v || 'Contact address is mandatory']"
						class="fullwidth"
						filled
						label="Email-address"
						prepend-icon="mdi-at"
						required
						v-model="data.email"
					></v-text-field>
				</v-list-item-content>
			</v-list-item>
		</v-list>
</template>

<script>
	export default {
		name: 'ContactForm',
		props: ['data']
	}
</script>
